/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const AdminPlanComputePost = {
  id: 'admin-plan-compute.post',
  tag: 'Admin',
  summary: 'Admin Compute plan creation',
  description: 'Create compute plan',
  method: 'post',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => `/administration/plan/compute`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            cpu: z.number().min(0),
            memory: z.number().min(1),
            replicaMin: z.number().min(1),
            replicaMax: z.number().min(1),
            replicaDefault: z.number().min(1),
            name: z.string().min(1),
            isVisible: z.boolean(),
            serviceType: ZodTypes.ServiceType,
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
